import { useI18n } from "@/i18n/I18nContext";

export default function Marquee() {
  const { t } = useI18n();
  const text = t("marquee");
  return (
    <section className="section-dark py-6 border-y border-white/10 overflow-hidden" aria-hidden="false">
      <div className="flex whitespace-nowrap will-change-transform marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center gap-8 pr-8 shrink-0">
            {Array.from({ length: 4 }).map((_, i) => (
              <span
                key={`${k}-${i}`}
                className="font-serif-display italic text-3xl md:text-5xl text-[#FAF9F6]"
              >
                {text}
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
